{
  "de": {
    "unit": {
      "actions": {
        "bulk": {
          "activate": "Einheiten aktivieren",
          "allow_customer_issue_creation": "Kunden Punkte erstellen lassen",
          "block_customer_issue_creation": "Kunden keine Punkte erstellen lassen",
          "deactivate": "Einheiten deaktivieren",
          "give_access": "Kunden Zugriff gewähren",
          "revoke_access": "Kundenzugriff entziehen"
        },
        "go_to_unit": "Zur Einheit gehen",
        "revokeAccess": "Zugriff entziehen",
        "select": "Typ auswählen",
        "selectOutdoorCategory": "Außenbereich auswählen",
        "selectUnit": "Einheit auswählen",
        "setCustomer": "Einen Kunden zuweisen an",
        "setVisible": "Zugriff gewähren",
        "submit": "Absenden",
        "update_pricing": "Preise aktualisieren"
      },
      "attributes": {
        "address_city": "Stadt",
        "address_country": "Land",
        "address_number": "Hausnummer",
        "address_street": "Straße",
        "address_zip": "Postleitzahl",
        "amount": "Betrag",
        "bathrooms": "Anzahl Badezimmer",
        "bedrooms": "Anzahl Schlafzimmer",
        "category": "Typ",
        "category_outdoor": "Außenbereich",
        "customer": "Kunde",
        "deed_signed_at": "Datum der Vertragsunterzeichnung",
        "description": "Beschreibung",
        "electricity": "Strom",
        "floor": "Etage",
        "house_subcategory": "Wohnungstyp",
        "internal_note": "Interne Notiz zur Einheit",
        "meter_number": "Zählernummer",
        "meter_number_electricity": "Zählernummer Strom",
        "meter_number_gas": "Zählernummer Gas",
        "meter_number_warmth": "Zählernummer Wärme",
        "meter_number_water": "Zählernummer Wasser",
        "meter_numbers": "Zählernummern",
        "name": "Name",
        "orientation": "Ausrichtung",
        "price_value": "Gesamtverkaufswert",
        "price_value_construction": "Baukosten",
        "price_value_construction_existing": "Kosten der bestehenden Bausubstanz",
        "price_value_fees": "Architekten-/Ingenieurhonorare",
        "price_value_land": "Grundstückswert",
        "quotity": "Anteil am Übertragungsbetrag",
        "sales_employee": "Verkaufsmitarbeiter",
        "surface_garden": "Gartenfläche",
        "surface_terrace": "Terrassenfläche",
        "surface_total": "Gesamtfläche",
        "tax_percentage": "Steuer %",
        "toilets": "Anzahl Toiletten",
        "total": "Gesamt",
        "vat_percentage": "MwSt. %"
      },
      "house_subtype": {
        "detached": "Freistehendes Haus",
        "rowhouse": "Reihenhaus",
        "semidetached": "Doppelhaushälfte"
      },
      "labels": {
        "activate": "Aktivieren",
        "address": "Adresse",
        "areYouSureDeactivate": "Sind Sie sicher, dass Sie {unit_name} deaktivieren möchten?",
        "bathrooms": "Badezimmer | Badezimmer",
        "bedrooms": "Schlafzimmer | Schlafzimmer",
        "cannot_activate_all_units": "Sie haben nicht genügend verbleibende Einheiten, um alle ausgewählten Einheiten zu aktivieren",
        "customer_can_create_issue_project_off": "Für das ganze Projekt in den Projekteinstellungen ausgeschaltet.",
        "customer_issue_creation_unit_off": "Für diese Einheit können Sie keine Punkte mehr melden.",
        "deactivate": "Deaktivieren",
        "deactivateMessage": "Der Kunde kann weiterhin mit Ihnen kommunizieren und behält Zugriff auf alle seine Informationen. Alle anderen Aktionen für {unit_name}, wie das Erstellen von Entscheidungen, das Hochladen von Dokumenten oder das Versenden von Umfragen, sind dennoch nicht möglich.",
        "deactivated": "Deaktiviert",
        "notAvailableDeactivated": "Nicht verfügbar für eine deaktivierte Einheit",
        "deedSignedOn": "Vertrag unterzeichnet am {date}",
        "deedWillBeSignedOn": "Vertrag wird am {date} unterzeichnet",
        "detailed_price": "Detailliert",
        "details": "Details",
        "email_address_secondary_delivery_content": "erhält als ehemaliger sekundärer Kontakt weiterhin Benachrichtigungs-E-Mails",
        "email_address_secondary_delivery_tip": "Dieser Kunde wurde ursprünglich als sekundärer Kontakt des anderen Kunden hinzugefügt, bevor die Unterstützung für mehrere Kunden pro Einheit eingeführt wurde: Dieser Kunde erhält weiterhin dieselben Benachrichtigungs-E-Mails wie der andere Kunde, jedoch hat nur der andere Kunde Zugriff auf die Einheit/den Login.",
        "existingVatValues": "Einige MwSt.-Werte sind ungleich 0",
        "export": "Exportieren",
        "export_preparing": "Das Zusammenstellen der Daten der Einheit kann einige Sekunden dauern.",
        "facing": "Ausrichtung {direction}",
        "fromATotal": "Projekt gesamt: {total}",
        "general": "Allgemein",
        "howDoesCustomerSeeThis": "Wie sieht der Kunde seine Einheit?",
        "integrationNoCustomerAssigned": "Kein(e) Kunde(n) zugewiesen. Bitte weisen Sie Kunde(n) in {integration_name} zu.",
        "internal": "Intern",
        "internalDisclaimer": "Diese Informationen sind nur für Ihr Team sichtbar",
        "invitationAddEmailAddress": "Um {customer} Zugriff auf die Einheit zu geben, füllen Sie bitte zuerst die E-Mail-Adresse auf der Kontaktseite des Kunden aus.",
        "invitationAddEmailAddress_SUP": "Um {customer} Zugriff auf das Projekt zu geben, füllen Sie bitte zuerst die E-Mail-Adresse auf der Kontaktseite des Kunden aus.",
        "invitationSentTo": "{customer} erhält seine Einladung in Kürze unter {email}",
        "maintainerNoCustomerAssigned": "Kein Kunde zugewiesen, nur Teammitglieder mit der Rolle „Inhaber“ können einer Einheit einen Kunden zuweisen.",
        "more": "mehr",
        "onFloor": "Auf Etage",
        "or_create_new": "Neu erstellen",
        "other_units": "Hat weitere Einheiten",
        "price_view": "Preisansicht",
        "sales_value": "Alle Preise sind in {currency}",
        "scopes": {
          "invisible": "Kein Zugriff auf Einheit",
          "invisible_SUP": "Kein Zugriff auf Projekt",
          "visible": "Hat Zugriff",
          "visible_SUP": "Hat Zugriff"
        },
        "scopes_description": {
          "invisible": "Der Kunde hat noch keinen Zugriff auf diese Einheit im Kundenportal",
          "invisible_SUP": "Der Kunde hat noch keinen Zugriff auf dieses Projekt im Kundenportal",
          "visible": "Der Kunde hat Zugriff auf diese Einheit im Kundenportal",
          "visible_SUP": "Der Kunde hat Zugriff auf diese Einheit im Kundenportal"
        },
        "search_unit": "Einheit oder Kunde suchen …",
        "selectUnit": "Eine Einheit auswählen",
        "select_contact_required": "Bitte wählen Sie zuerst einen Kontakt aus",
        "select_existing_contact": "Bestehend",
        "set_unit_price": "Preis der Einheit festlegen",
        "showUnit": "Einheit anzeigen",
        "simple_price": "Einfach",
        "toggleDetailedPrice": "Preisansicht wechseln",
        "unassigned": "Kein Kunde zugewiesen",
        "unit": "Keine Einheit | Eine Einheit | {count} Einheiten",
        "unitLabel": "Einheit",
        "units": "Einheiten",
        "units_assigned_count": "{assigned} / {total} Einheiten",
        "units_not_added": "{count} Einheit noch nicht hinzugefügt | {count} Einheiten noch nicht hinzugefügt",
        "utilities": "Versorgungsleistungen",
        "visibleCustomer": "Diese Informationen sind für Kunden sichtbar"
      },
      "outdoor_category": {
        "balcony": "Balkon",
        "garden": "Garten",
        "null": "Keine",
        "terrace": "Terrasse",
        "terrace_garden": "Terrasse + Garten"
      },
      "status": {
        "unavailable": "Nicht verfügbar"
      },
      "toasts": {
        "activateSuccess": "{unit_name} wurde erfolgreich aktiviert",
        "create_fixed": "Einheit wurde erstellt",
        "create_rundle": "Neue aktive Einheit erstellt. Noch 1 aktive Einheit übrig. | Neue aktive Einheit erstellt. Noch {count} aktive Einheiten übrig.",
        "deactivateSuccess": "{unit_name} wurde erfolgreich deaktiviert",
        "delete": "Einheit wurde gelöscht",
        "update": "Einheit wurde aktualisiert"
      },
      "type": {
        "alf": "Betreutes Wohnen",
        "apartment": "Wohnung",
        "cellar": "Keller",
        "commercial": "Gewerbe",
        "duplex": "Maisonette",
        "house": "Haus",
        "loft": "Loft",
        "office": "Büro",
        "penthouse": "Penthouse",
        "sme": "KMU-Einheit",
        "studio": "Studio"
      },
      "validation": {
        "needName": "Titel ist erforderlich",
        "needNumber": "Muss eine Zahl sein (z. B. 85)",
        "pricesNotUpdatable": "Einige oder alle Preise wurden für Raten verwendet und können daher nicht bearbeitet werden. Entfernen Sie die zugehörigen Raten, um die Preise wieder bearbeiten zu können",
        "totalSalesValueNotEqualToParts": "Es sieht so aus, als ob der Gesamtverkaufswert nicht der Summe seiner Teile entspricht"
      }
    }
  }
}
